import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="alerts-bulk"
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "actionSelect", "submitButton", "selectedCount"]

  connect() {
    this.update()
  }

  toggleAll() {
    if (!this.hasSelectAllTarget) return

    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })

    this.update()
  }

  selectByStatus(event) {
    const status = event.params.status
    this.checkboxTargets.forEach((checkbox) => {
      const row = checkbox.closest("tr")
      if (!row) return
      const statusBadge = row.querySelector("[data-status]")
      checkbox.checked = statusBadge ? statusBadge.dataset.status === status : false
    })

    this.update()
  }

  update() {
    const selectedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = String(selectedCount)
    }

    if (this.hasSelectAllTarget && this.checkboxTargets.length > 0) {
      this.selectAllTarget.checked = selectedCount === this.checkboxTargets.length
      this.selectAllTarget.indeterminate = selectedCount > 0 && selectedCount < this.checkboxTargets.length
    }

    const hasAction = this.hasActionSelectTarget ? this.actionSelectTarget.value.length > 0 : false
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = selectedCount === 0 || !hasAction
    }
  }
}
